import z from 'zod';

export const RECORD_TYPE = {
  MANUFACTURE: 'MANUFACTURE',
  PACKAGE: 'PACKAGE',
} as const;

export const recordSchema = z.object({
  recordType: z.enum([RECORD_TYPE.MANUFACTURE, RECORD_TYPE.PACKAGE]),
  file: z
    .instanceof(File, { message: '파일을 선택해주세요.' })
    .nullable()
    .refine((file) => file !== null, {
      message: '파일을 선택해주세요.',
    }),
});

export const documentInfoSchema = z.object({
  dk_document_id: z.number(),
  main_code: z.string(),
  original_file_name: z.string(),
  total_contractor: z.number(),
  total_pages: z.number(),
});

export type DocumentInfo = z.infer<typeof documentInfoSchema>;

export const packageCMOInfoSchema = z.object({
  id: z.number(),
  pk_no: z.string(),
  seq_no: z.number(),
  product_company_name: z.string(),
  product_name: z.string(),
  product_code: z.string(),
  main_code: z.string(),
  document_no: z.string(),
  revision_no: z.string().min(1, { message: '개정번호를 입력해주세요.' }),
  product_standard_no: z.string(),
  code: z.string(),
  pill_marking_one: z.string(),
  pill_marking_two: z.string(),
  bar_code: z.string(),
  standard_code: z.string(),
});

export type PackageCMOInfo = z.infer<typeof packageCMOInfoSchema>;

export const manufactureCMOInfoSchema = z.object({
  id: z.number(),
  pk_no: z.string(),
  seq_no: z.number(),
  product_name: z.string(),
  main_code: z.string(),
  document_no: z.string(),
  revision_no: z.string().min(1, { message: '개정번호를 입력해주세요.' }),
  product_standard_no: z.string(),
  pill_marking_one: z.string(),
  pill_marking_two: z.string(),
});

export type ManufactureCMOInfo = z.infer<typeof manufactureCMOInfoSchema>;

// Preparation API 응답 타입
export interface PreparationResponse<T = ManufactureCMOInfo | PackageCMOInfo> {
  dk_document_id: number;
  main_code: string;
  original_file_name: string;
  total_contractor: number;
  total_pages: number;
  data_list: T[];
}

export const createRecordRequestSchema = z.object({
  recordType: z.enum([RECORD_TYPE.MANUFACTURE, RECORD_TYPE.PACKAGE]),
  dkDocumentId: z.string(),
  fields: z.array(
    z.object({
      revision_no: z.string().min(1, { message: '개정번호를 입력해주세요.' }),
      id: z.number().min(1, { message: '문서를 선택해주세요.' }),
    })
  ),
});

export type CreateRecordRequest = z.infer<typeof createRecordRequestSchema>;
